<p-dialog [(visible)]="isModalVisable" [style]="{width: '35vw'}" [modal]="true" (onHide)="onDialogHide()">
 <ng-template pTemplate="header">
    <span class="font-semibold text-xl">{{heading}}</span>
  </ng-template>

  <div *ngIf="isReasonForDocumentUpdateRequired">
    <p-messages severity="error">
      <ng-template pTemplate> 
        <span class="p-message-icon pi pi-times-circle"></span>
        <span class="p-ml-2">Please correct the following errors.</span>   
        <ul>
          <li><span>{{reasonValidationMessage}}</span></li>
        </ul>          
                          
      </ng-template>
    </p-messages>
    </div>
    <div>
      <span>{{ confirmationMessage }}</span>
    </div>
  <div class="documentReason pt-3">
    <bpt-text-input  [rows]="5"
    [cols]="150" [highlightAllOnFocus]="true" [multiLine]="true" [autoResize]="true" [maxlength]="250"  [(ngModel)]="reason"
    id="reason" label="{{heading}}" [required]="true"></bpt-text-input>
  </div>  

  <ng-template pTemplate="footer">
    
    <p-button
    appPreventDoubleClick
      label="Cancel"
      type="submit"
      id="cancleReason"
      styleClass="p-button-outlined"
      class="align-right"
      (debounceClick)="closeReasonDailog()"
    >
    </p-button>
    <p-button
    appPreventDoubleClick
      label="Submit"
      type="submit"
      id="saveReasonText"
      class="align-right"
      (debounceClick)="saveDocument()"
    >
    </p-button>
  </ng-template>
</p-dialog>
